/**
 * buildPaletteCommands — derives a `CommandItem[]` for the Cmd+K
 * command palette from the central `ROUTE_MANIFEST`.
 *
 * Single source of truth for navigation entries: editing the manifest
 * in `routes.tsx` updates both the explicit React-Router routes AND
 * the palette listings. No hardcoded path strings here.
 */
import type { NavigateFunction } from "react-router-dom";

import type { CommandItem } from "./CommandPalette";
import { ROUTE_MANIFEST, type RouteEntry } from "../route-manifest";

export function buildPaletteCommands(navigate: NavigateFunction): CommandItem[] {
  return ROUTE_MANIFEST.map((entry: RouteEntry) => ({
    id: `nav:${entry.path}`,
    label: entry.label,
    hint: entry.hint ?? entry.path,
    section: entry.section,
    onRun: () => navigate(entry.path),
  }));
}
